<template>
    <div id="global-uploader">

        <!-- 上传 -->
        <uploader
            ref="uploader"
            :options="options"
            :fileStatusText="fileStatusText"
            :autoStart="false"
            @file-added="onFileAdded"
            @file-success="onFileSuccess"
            @file-progress="onFileProgress"
            @file-error="onFileError"
            class="uploader-app">
            <uploader-unsupport></uploader-unsupport>

            <!-- :attrs="attrs"-->
            <uploader-btn id="global-uploader-btn" ref="uploadBtn">{{$t('res.chooseFile')}}</uploader-btn>

            <uploader-list v-show="panelShow">
                <div class="file-panel" slot-scope="props" :class="{'collapse': collapse}">
                    <div class="file-title">
                        <h2>{{$t('res.fileList')}}</h2>
                        <div class="operate">
                            <el-button @click="fileListShow" type="text" :title="collapse ? $t('res.expand'):$t('res.fold') ">
                                <i class="nucfont" :class="collapse ? 'inuc-fullscreen': 'inuc-minus-round'"></i>
                            </el-button>
                            <el-button @click="close" type="text" :title="$t('c.close')">
                                <i class="nucfont inuc-close"></i>
                            </el-button>
                        </div>
                    </div>

                    <ul class="file-list">
                        <li :class="`file-${file.id}`" v-for="file in props.fileList" :key="file.id">
                            <uploader-file :class="'file_' + file.id" ref="files" :file="file" :list="true"></uploader-file>
                        </li>
                        <div class="no-file" v-if="!props.fileList.length"><i class="nucfont inuc-empty-file"></i> {{$t('res.noUploadFile')}}</div>
                    </ul>
                </div>
            </uploader-list>

        </uploader>

    </div>
</template>

<script>
    /**
     *   调用方法：Bus.$emit('openUploader', {params: {}, options: {}})
     *               params: 发送给服务器的额外参数；
     *               options：上传选项，目前支持target、testChunks、mergeFn、accept
     *
     *   监听函数：Bus.$on('fileAdded', fn); 文件选择后的回调
     *            Bus.$on('fileSuccess', fn); 文件上传成功的回调，监听后记得释放
     */
    import {Ticket} from '@/utils';
    import Bus from '@/utils/bus';
    import {ACCEPT_CONFIG} from '@/config/constant';
    import api from '@/api';
    import SparkMD5 from 'spark-md5';

    export default {
        data() {
            return {
                options: {
                    target: api.simpleUploadURL,
                    chunkSize: '2048000',
                    fileParameterName: 'upfile',
                    testChunks: true,     //是否开启秒传、断点续传
                    maxChunkRetries: 3,
                    checkChunkUploadedByResponse: function (chunk, message) {
                        var objMessage = JSON.parse(message);
                        //console.log(objMessage)
                        if (objMessage.skipUpload) {
                            return true;
                        }

                        return (objMessage.uploaded || []).indexOf(chunk.offset + 1) >= 0
                    },
                    headers: {
                    },
                    query: (file, chunk) => {
                        return {
                            ...file.params,
                            culture: this.$i18n.locale,
                            'ui-culture': this.$i18n.locale,
                        }
                    },
                },
                fileStatusText: {
                    success: this.$t('res.success'),
                    error: this.$t('res.error'),
                    uploading: this.$t('res.uploading'),
                    paused: this.$t('res.paused'),
                    waiting: this.$t('res.waiting')
                },
                panelShow: false,   //选择文件后，展示上传panel
                collapse: false,

                params: {},
                mergeFn: api.mergeSimpleUpload,
            }
        },
        created() {
        },
        mounted() {
            Bus.$on('openUploader', ({params={}, options={}}) => {
                this.params = params;

                this.customizeOptions(options);

                if (this.$refs.uploadBtn) {
                    $('#global-uploader-btn').click();
                }
            });
        },
        computed: {
            //Uploader实例
            uploader() {
                return this.$refs.uploader.uploader;
            },
        },
        methods: {
            // 自定义options
            customizeOptions(opts) {
                // 自定义上传url
                this.uploader.opts.target = opts.target || api.simpleUploadURL;

                // 是否可以秒传、断点续传
                this.uploader.opts.testChunks = opts.testChunks !== undefined? opts.testChunks: true;

                // merge 的方法，类型为Function，返回Promise
                this.mergeFn = opts.mergeFn && opts.mergeFn.bind(api) || api.mergeSimpleUpload.bind(api);

                // 自定义文件上传类型
                let $input = $('#global-uploader-btn').find('input')
                let accept = opts.accept || ACCEPT_CONFIG.getAll()
                $input.attr('accept', accept.join())
            },

            onFileAdded(file) {
                this.panelShow = true;
                this.computeMD5(file);

                // 2022/1/10 将额外的参数赋值到每个文件上，解决了不同文件使用不同params的需求
                file.params = this.params

                Bus.$emit('fileAdded');
            },
            onFileProgress(rootFile, file, chunk) {
                console.log(`上传中 ${file.name}，chunk：${chunk.startByte / 1024 / 1024} ~ ${chunk.endByte / 1024 / 1024}`)
            },
            onFileError(rootFile, file, response, chunk) {
                this.$message({
                    message: response,
                    type: 'error'
                })
            },

            /**
             * 计算md5，实现断点续传及秒传
             * @param file
             */
            computeMD5(file) {
                let fileReader = new FileReader();
                let time = new Date().getTime();
                let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
                let currentChunk = 0;
                const chunkSize = 10 * 1024 * 1000;
                let chunks = Math.ceil(file.size / chunkSize);
                let spark = new SparkMD5.ArrayBuffer();

                this.statusSet(file.id, 'md5');
                file.pause();

                this.$nextTick(() => {
                    $(`.file-${file.id} .uploader-file-resume`).hide()   // 计算md5时隐藏开始按钮
                })

                loadNext();

                fileReader.onload = (e => {
                    spark.append(e.target.result);

                    if (currentChunk < chunks) {
                        currentChunk++;
                        loadNext();

                        this.$nextTick(() => {
                            $(`.myStatus_${file.id}`).text(this.$t('res.checkMD5') +' '+ ((currentChunk/chunks)*100).toFixed(0)+'%')
                        })
                    } else {
                        let md5 = spark.end();
                        this.computeMD5Success(md5, file);
                        console.log(`MD5计算完毕：${file.name} \nMD5：${md5} \n分片：${chunks} 大小:${file.size} 用时：${new Date().getTime() - time} ms`);
                    }
                });

                fileReader.onerror = function () {
                    this.error(`文件${file.name}读取出错，请检查该文件`)
                    file.cancel();
                };

                function loadNext() {
                    let start = currentChunk * chunkSize;
                    let end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;

                    fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
                }
            },

            computeMD5Success(md5, file) {
                // 将自定义参数直接加载uploader实例的opts上
                Object.assign(this.uploader.opts, {
                    headers: {
                        Authorization: Ticket.get() && "Bearer " + Ticket.get().access_token
                    },
                })

                $(`.file-${file.id} .uploader-file-resume`).show()

                file.uniqueIdentifier = md5;

                file.resume();

                this.statusRemove(file.id);
            },

            onFileSuccess(rootFile, file, response, chunk) {
                let res = JSON.parse(response);

                // 服务器自定义的错误，这种错误是Uploader无法拦截的
                if (!res.result) {
                    this.$message({ message: res.message, type: 'error' });
                    this.statusSet(file.id, 'failed');
                    return
                }

                if (res.needMerge) {
                    this.statusSet(file.id, 'merging');

                    this.mergeFn({
                        tempName: res.tempName,
                        fileName: file.name,
                        totalChunks: res.totalChunks,
                        ...file.params,
                    }).then(data => {
                        this.statusRemove(file.id);

                        if (data.status === 0) {
                            console.log('上传成功，转码中');
                            this.statusSet(file.id, 'transcoding');
                        } else if (data.status === 1) {
                            console.log('上传失败');
                        } else if (data.status === 2) {
                            console.log('上传成功');
                        }
                        Bus.$emit('fileSuccess', data);
                    }).catch(e => {
                        this.statusSet(file.id, 'failed');
                    });
                } else {
                    Bus.$emit('fileSuccess', res);
                    console.log('上传成功');
                }
            },

            fileListShow() {
                let $list = $('#global-uploader .file-list');

                if ($list.is(':visible')) {
                    $list.slideUp();
                    this.collapse = true;
                } else {
                    $list.slideDown();
                    this.collapse = false;
                }
            },
            close() {
                this.uploader.cancel();

                this.panelShow = false;
            },

            /**
             * 新增的自定义的状态: 'md5'、'transcoding'、'failed'
             * @param id
             * @param status
             */
            statusSet(id, status) {
                let statusMap = {
                    md5: {
                        text: this.$t('res.checkMD5'),
                        bgc: '#fff'
                    },
                    merging: {
                        text: this.$t('res.merging'),
                        bgc: '#e2eeff'
                    },
                    transcoding: {
                        text: this.$t('res.transcoding'),
                        bgc: '#e2eeff'
                    },
                    failed: {
                        text: this.$t('res.uploadFail'),
                        bgc: '#e2eeff'
                    }
                }

                this.$nextTick(() => {
                    $(`<p class="myStatus_${id}"></p>`).appendTo(`.file_${id} .uploader-file-status`).css({
                        'position': 'absolute',
                        'top': '0',
                        'left': '0',
                        'right': '0',
                        'bottom': '0',
                        'zIndex': '1',
                        'backgroundColor': statusMap[status].bgc
                    }).text(statusMap[status].text);
                })
            },
            statusRemove(id) {
                this.$nextTick(() => {
                    $(`.myStatus_${id}`).remove();
                })
            },

            error(msg) {
                this.$notify({
                    title: this.$t('c.error'),
                    message: msg,
                    type: 'error',
                    duration: 3000
                })
            }
        },
        watch: {},
        destroyed() {
            Bus.$off('openUploader');
        },
        components: {}
    }
</script>

<style scoped lang="scss">
    #global-uploader {
        position: fixed;
        z-index: 20;
        right: 15px;
        bottom: 15px;

        .uploader-app {
            width: 520px;
        }

        .file-panel {
            background-color: #fff;
            border: 1px solid #e2e2e2;
            border-radius: 7px 7px 0 0;
            box-shadow: 0 0 10px rgba(0, 0, 0, .2);

            .file-title {
                display: flex;
                height: 40px;
                line-height: 40px;
                padding: 0 15px;
                border-bottom: 1px solid #ddd;

                .operate {
                    flex: 1;
                    text-align: right;
                }

                button {

                }
            }

            .file-list {
                position: relative;
                height: 240px;
                //max-height: 380px;
                overflow-x: hidden;
                overflow-y: auto;
                background-color: #fff;

                > li {
                    background-color: #fff;
                }
            }

            &.collapse {
                .file-title {
                    background-color: #E7ECF2;
                }
            }
        }

        .no-file {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 16px;
        }
    }

    #global-uploader-btn {
        position: absolute;
        clip: rect(0, 0, 0, 0);
    }
</style>
<style lang="scss">
    #global-uploader {

        .uploader-file-icon {
            &:before {
                content: '' !important;
            }

            &[icon=image] {
                background: url(../assets/images/icon/image-icon.png);
            }
            &[icon=video] {
                background: url(../assets/images/icon/video-icon.png);
            }
            &[icon=audio] {
                background: url(../assets/images/icon/audio-icon.png);
                background-size: contain;
            }
            &[icon=document] {
                background: url(../assets/images/icon/text-icon.png);
            }
            &[icon=unknown] {
                background: url(../assets/images/icon/zip.png) no-repeat center;
                background-size: contain;
            }

        }

        .uploader-file-size {
            text-indent: 5px;
            width: 15%;
        }

        .uploader-file-meta {
            width: 6%;
        }

        .uploader-file-actions > span {
            margin-right: 6px;
        }

    }
</style>
